import type { CockpitConfidence } from '@internal/spassu-code-contract';
import { confidenceLabel } from '../model/semanticLabels';
import { useCockpitStyles } from './cockpitStyles';

const confidenceShape: Record<CockpitConfidence, string> = {
  confirmed: 'circle-filled',
  calculated: 'square',
  estimated: 'diamond',
  detected: 'ring',
  inferred: 'diamond',
  partial: 'semicircle',
  unavailable: 'dash',
  'load-failed': 'cross',
};

const confidenceClass: Record<
  CockpitConfidence,
  keyof ReturnType<typeof useCockpitStyles>
> = {
  confirmed: 'confidenceConfirmed',
  calculated: 'confidenceCalculated',
  estimated: 'confidenceEstimated',
  detected: 'confidenceDetected',
  inferred: 'confidenceInferred',
  partial: 'confidencePartial',
  unavailable: 'confidenceUnavailable',
  'load-failed': 'confidenceLoadFailed',
};

export const EvidenceConfidenceMarker = ({
  confidence,
}: {
  confidence: CockpitConfidence;
}) => {
  const classes = useCockpitStyles();
  return (
    <span className={classes.confidenceDisplay}>
      <span
        className={`${classes.confidenceMarker} ${
          classes[confidenceClass[confidence]]
        }`}
        data-confidence={confidence}
        data-confidence-shape={confidenceShape[confidence]}
        aria-hidden="true"
      />
      <span>{confidenceLabel(confidence)}</span>
    </span>
  );
};
